import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "./UserDetailBook.css";

class Specification extends Component {
  render() {
    const { classes, bookData, authorData } = this.props;
    return (
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        xl={12}
        lg={12}
        className={classes.contentRoot}
      >
        <Paper style={{ padding: 20 }}>
          <ListItem>Title: {bookData.title}</ListItem>
          <ListItem>
            Author: {authorData.firstName} {authorData.lastName}
          </ListItem>
          <ListItem>Genre: {bookData.genre}</ListItem>
          <ListItem>Price: {bookData.price}</ListItem>
          <ListItem>Total Page: {bookData.pageCount}</ListItem>
          <ListItem>Published Date: {bookData.publishedDate}</ListItem>
        </Paper>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(Specification);
